import React from "react";
import icons from "../../../../../assets/images/icons";
import styles from "./BackHeader.module.scss";
/**
 * 뒤로가기 + 제목 헤더 (설정/차단 등 서브 페이지 공통)
 */
function BackHeader({ className = "", title = "", onBackClick }) {
  return (
    <div className={`${styles.root} ${className}`.trim()}>
      <div className={styles.bar}>
        <button type="button" className={styles.backBtn} onClick={onBackClick} aria-label="뒤로">
          <img
            src={icons.messager?.chevronLeft}
            alt=""
            className={styles.backIcon}
            width={24}
            height={24}
          />
        </button>
        <h1 className={styles.title}>{title}</h1>
      </div>
      <div className={styles.divider} />
    </div>
  );
}

export default BackHeader;
